import { AccountMenu } from 'components/navigation/top_nav/components';
import { useNavDrawer } from 'components/navigation/nav_drawer';
import { Navbar } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import { useApp } from 'app';

import 'components/navigation/top_nav/styles/TopNav.scss';

/** Maps ETypePartner role ID → border color + hierarchy text color. */
const ROLE_CONFIG: Record<number, { color: string; }> = {
    1: { color: '#516487' },
    2: { color: '#6baa6b' },
    3: { color: '#e2ac5a' },
    4: { color: '#f37223' },
    5: { color: '#a36a6a' },
    6: { color: '#f37223' }
};

export const TopNav = () => {

    const { highestRole } = useApp();
    const { formatMessage } = useIntl();
    const { isMobile, isOpen, toggle } = useNavDrawer();

    const roleId = highestRole?.id ?? 0;
    const config = ROLE_CONFIG[roleId];

    const roleLabels: Record<number, string> = {
        1: formatMessage({ id: 'system_admin.65a5b365', defaultMessage: 'System Admin' }),
        2: formatMessage({ id: 'distributor.8955b2a4', defaultMessage: 'Distributor' }),
        3: formatMessage({ id: 'reseller.8d01b60c', defaultMessage: 'Reseller' }),
        4: formatMessage({ id: 'administrator.853b8dd0', defaultMessage: 'Administrator' }),
        5: formatMessage({ id: 'association.2db9d5b7', defaultMessage: 'Association' }),
        6: formatMessage({ id: 'administrator.853b8dd0', defaultMessage: 'Administrator' })
    };

    return (
        <Navbar
            style={{
                borderBottom: config ? `3px solid ${config.color}` : undefined,
                height: 70
            }}
            className="top-nav p-0 d-print-none shadow-sm bg-white flex-shrink-0"
        >
            <div className="px-3 flex-fill">
                <div className="top-nav-content row h-100 w-100 align-items-center gx-0">

                    {/* Left: hamburger — only shown on phones (< 576px) to open the sidenav drawer */}
                    <div className="top-nav-content-left col d-flex align-items-center d-sm-none">
                        {isMobile && (
                            <button
                                aria-controls="side-nav-drawer"
                                aria-expanded={isOpen}
                                aria-label={formatMessage({ id: 'toggle_navigation.671a2a4a', defaultMessage: 'Toggle navigation' })}
                                className="top-nav-hamburger btn btn-link text-dark p-2"
                                onClick={toggle}
                                type="button"
                            >
                                <i aria-hidden="true" className="fa-solid fa-bars fa-lg" />
                            </button>
                        )}
                    </div>

                    {/* Right: account menu + hierarchy label */}
                    <div className="top-nav-content-right col d-flex justify-content-end align-items-center">
                        <div>
                            <AccountMenu />
                            <div className="d-none d-md-flex justify-content-end align-items-center column-gap-2 small">
                                {config && (
                                    <span className="text-nowrap" style={{ color: config.color }}>
                                        {roleLabels[roleId]}
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </Navbar>
    );

};